<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
});

const getFunnel = useMapGetter('funnels/getFunnel');

const funnelInfo = computed(() => {
  const { funnel_mappings = [] } = props.conversation;

  // Pegar o primeiro funnel mapping (pode ter múltiplos funis)
  const mapping = funnel_mappings[0];
  if (!mapping) return null;

  // Garantir que o ID é number para comparação
  const funnelId =
    typeof mapping.funnel_id === 'string'
      ? parseInt(mapping.funnel_id, 10)
      : mapping.funnel_id;

  const funnel = getFunnel.value(funnelId);
  if (!funnel) return null;

  // Buscar configuração da etapa para pegar o label
  const stageConfig = funnel.stages?.[mapping.stage_name];
  const stageLabel = stageConfig?.label || mapping.stage_name;

  return {
    funnelName: funnel.name,
    stageName: stageLabel,
    stageColor: stageConfig?.color || '#3B82F6',
  };
});

const hasKanbanInfo = computed(() => !!funnelInfo.value);
</script>

<template>
  <div
    v-if="hasKanbanInfo"
    class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium truncate max-w-full"
    :style="{
      backgroundColor: funnelInfo.stageColor + '20',
      color: funnelInfo.stageColor,
    }"
  >
    <span class="i-lucide-circle-dot size-3 flex-shrink-0" />
    <span class="truncate">{{ funnelInfo.funnelName }}</span>
    <span class="flex-shrink-0">|</span>
    <span class="truncate font-semibold">{{ funnelInfo.stageName }}</span>
  </div>
</template>
